import React, { useState, useEffect, useRef } from "react";
import 'react-nice-dates/build/style.css'
import { init, validatefrm, multijsoninit, initselect, inputEventChecker } from "../../../../assets/js/formbuilder";
import { Http } from '../../../../Core/Services/HttpService';
import { FiPlusCircle, FiTrash2, FiEye } from 'react-icons/fi'
import { Link, useLocation, useNavigate } from "react-router-dom";
import { BiUpload,BiDownload } from 'react-icons/bi';
import swal from 'sweetalert';
import { useStateMounted } from "../../../../Core/Hooks";
import { Alert, OverlayTrigger, Tooltip } from 'react-bootstrap';

// Images
import FieldComponent from "../../../../FieldComponent";


export const LoadingSpinner = () => {
    return (
        <div className="spinner-container">
            <div className="spinner-outer">
                <div className="loading-spinner"></div>
            </div>
        </div>
    );
}

type CreateNewProps = {
    apiurl: string;
    districts:any;
    refresh:any;
    selected:any;
    months:any;
};

const Block1 = (props: any) => {

    let block1SrNo = 0;
    const [hasBlock2FieldsDelete, setHasBlock2FieldsDeletes] = useState<boolean>(false);
    const [block1Fields, setBlock2fields] = useState<any>([]);
    const [newBlock2Fields, setNewBlock2fields] = useState<any>([]);

    useEffect(() => {
      if (props.field1) {
          setHasBlock2FieldsDeletes(false);
          setBlock2fields([]);
          setNewBlock2fields(props.field1.addnew);
          setTimeout(() => {
            const fields1 = props.field1.childrens.map((items:  any) => {
                return {
                    fields: items,
                    delete: false
                }
            })
            setBlock2fields(fields1);
         }, 500);
      }
  }, [props.field1]);

    useEffect(() => {
        if (block1Fields.length) {
            const hasDelete = (block1Fields.filter((item: any) => item.delete === false).length > 1);
            setHasBlock2FieldsDeletes(hasDelete);
            block1SrNo = 0;
            inputEventChecker.removeAllEvent();
            setTimeout(() => {
                initselect();
                multijsoninit();
            }, 1000);
        }
    }, [block1Fields]);

    const addItem = (block?: any) => {
        setBlock2fields((prev: any[]) => {
            return [...prev, { fields: newBlock2Fields, delete: false }];
        });
        
        setTimeout(() => {
            initselect();
            multijsoninit();
        }, 500);
    }

    const removeItem = (rindex: number, block?: any) => {
        setBlock2fields((prev: any[]) => {
            const newFields = prev.map((item, index) => {
                if (index === rindex) {
                    item.delete = true;
                }
                return item;
            })
            return newFields;
        });

        setTimeout(() => {
            initselect();
            multijsoninit();
        }, 500);
    }

    return (
        <>
        <table className="table caption-top newTableUcss">
            <thead className='text-center'>
                <tr>
                    <th rowSpan={2}>Sl No.</th>
                    <th rowSpan={2}>Date of completion of Test</th>
                    <th rowSpan={2}>Date of arrival of material at site stores</th>
                    <th rowSpan={2}>Name of Material</th>
                    <th rowSpan={2}>Details of Material Inspected</th>
                    <th rowSpan={2}>Rating / Capacity / Size</th>
                    <th rowSpan={2}>Name of Manufacturer</th>
                    <th rowSpan={2}>Name of Turnkey contractor</th>
                    <th rowSpan={2}>Name of Supplier</th>
                    <th rowSpan={2}>Lot Number</th>
                    <th rowSpan={2}>Lot Size</th>
                    <th rowSpan={2}>Unique Identification Number of the sample tested at PDI stage</th>
                    <th rowSpan={2}>Remarks</th>
                    <th rowSpan={2} className='text-end pe-1' style={{ width: "30px" }}>
                            <Link to="#" className='p-0 text-success' onClick={() => addItem()}><FiPlusCircle className="h5 p-0 mb-0" /></Link>
                    </th>
                </tr>
                
            </thead>
            <tbody>
                {
                    (block1Fields.length)
                        ? block1Fields.map((item: any, key: number) => {
                            return (item.delete === false) ? <>
                                <tr key={key}>
                                    <td className="text-center" >{(block1SrNo++) + 1}</td>
                                    {
                                        item.fields.map((field: any, fkey: number) => {
                                            return <>
                                                <td key={key + '_' + fkey}>
                                                    <FieldComponent options={{ showTitle: false, extraId: '_' + key + '_' + fkey }} fieldName={field.key} field={field} /></td>
                                                </>;
                                        })
                                    }
                                    <td className="text-end">{(hasBlock2FieldsDelete) ? <Link className='text-danger' to="#" onClick={() => removeItem(key, props.block)}><FiTrash2 className="p-0 mb-0 h5" /></Link> : null}</td>
                                </tr>
                                </>
                                : null;
                        })
                        : null
                }

            </tbody>
        </table>
        </>
    );
}

const CreateNew = (props: CreateNewProps) => {
    const target = useRef(null);
    const formData: any = useRef(null);
    const [refresh, setRefresh] = useState(false); 
    const [isLoaded, setIsLoaded] = useState(false);
    const [fields, setFields] = useState<any[]>([]);
    const [roleid, setRoleid] = useState<any>(0);
    const [apiurl, setApiurl] = useState<any>(null);
    const [discomid, setDiscomid] = useState<any>(0);
    const [districts, setDistricts] = useState<any[]>([]);
    const [getdistricts, setGetDistricts] = useState<any>(0);
    const [districtsresult, setDistrictsResult] = useState<any>(0);
    const [districtsdefaultvalue, setDistrictsDefaultValue] = useState<any>(0);
    const [isLoading, setIsLoading] = useState(false);
    const [discomuserid, setDiscomUserid] = useState<any>(0);
    const [fieldsvalues, setFieldsValues] = useState<any>(0);
    const [sampleFileLink, setSampleFileLink] = useStateMounted('#');
    const [error, setError] = useStateMounted<string>();
    const [loading, setLoading] = useStateMounted<boolean>(true);
    const location = useLocation();

    useEffect(() => {
        setRoleid(sessionStorage.getItem('roleid'));
        setDiscomid(sessionStorage.getItem('discom_id'));
        setDiscomUserid(sessionStorage.getItem('discom_user_id'));
    }, [props.apiurl, roleid, discomid]);

    const ChangeValue = (evt?: any) => {
        setGetDistricts(evt.target.value);
        setIsLoaded(true);
    };

    const getFields = (apiurl: any) => {
        setIsLoaded(true);
        Http.get(apiurl)
            .then((result) => {
                setIsLoaded(false);
                setFields(result.fields);
                setTimeout(() => {
                    init();
                    multijsoninit();
                }, 500);
            })
            .catch((error) => {
                setIsLoaded(false);
                setError(error);
            });
    };

    useEffect(() => {
        (async () => {
            getFields(props.apiurl);
        })();
    }, [props.apiurl]);

    const saveasdraft = () => {
        setIsLoading(true);
        setRefresh(false);
        const config = { headers: { 'Content-Type': 'multipart/form-data' } };
        let myFormData = new FormData(formData.current);
        myFormData.append('discom_id', discomid);
        myFormData.append('discom_user_id', discomuserid);
        myFormData.append('district_id', props.districts);
        myFormData.append('months', props.months);
        myFormData.append('block','0');

        Http.post('/apiv1/save-pre-dispatch-inspection', myFormData, config)
            .then((res) => {
                if (res._resultflag == 0) {
                    setIsLoading(false);
                    swal("Warning", res.message, "info");
                } else {
                    swal("Qa At Site Form", "Data have been saved", "success");
                    setIsLoading(false);
                    setRefresh(true);
                    getFields(props.apiurl);
                }
            });
    }

    const onSubmit = (e: any) => {
        e.preventDefault();
        setIsLoading(true);
        setRefresh(false);
        const config = { headers: { 'Content-Type': 'multipart/form-data' } };
        let myFormData = new FormData(formData.current);
        myFormData.append('discom_id', discomid);
        myFormData.append('discom_user_id', discomuserid);
        myFormData.append('district_id', props.districts);
        myFormData.append('months', props.months);
        myFormData.append('block', '1');

        if(props.districts)
        {
            swal({
                title: "Warning",
                text: "Upon submission, the form will be uneditable.Are you sure you would like to submit?",
                icon: "warning",
                buttons: [
                    'No, cancel it!',
                    'Yes, I am sure!'
                ],
                dangerMode: true,
            }).then(function (isConfirm) {
                if (isConfirm) {
                    swal({
                        title: 'Qa At Site Form!',
                        text: 'Your data has been submitted.',
                        icon: 'success'
                    }).then(function () {
                        Http.post('/apiv1/save-pre-dispatch-inspection', myFormData, config)
                            .then((res) => {
                                if (res._resultflag == 0) {
                                    setIsLoading(false);
                                    swal("Warning", res.message, "info");
                                } else {
                                    setIsLoading(false);
                                    setRefresh(true);
                                    getFields(props.apiurl);
                                }
                            });
                    });
                } else {
                    setIsLoading(false);
                }
            });
        }else{
            swal("Warning", 'Please select district', "info");
        }
    }

    const handleFileInput = (e: any) => {
        setLoading(true);
        setRefresh(false);
        setError('');
        const config = { headers: { 'Content-Type': 'multipart/form-data' } };
        let formData = new FormData();
        formData.append("file_to_upload", e.target.files[0]);
        formData.append("role_id", roleid);
        formData.append("discom_id", discomid);
        formData.append("form_id", "176");
        formData.append('district_id', props.districts);
        formData.append('months', props.months);
        setFields([]);
        Http.post('/apiv1/pre-dispatch-inspection-import', formData, config)
          .then((res) => {
            if (res.resultflag && res.fields) {
                if (res.fields && Array.isArray(res.fields)) {
                    if (!res.fields.length) setError("No data found.");
                    setFields(res.fields);
                    setDistrictsResult(res.district_id);
                    setTimeout(() => {
                        init();
                        multijsoninit();
                    }, 2000);
                    console.log("File uploaded successfully");
                } else {
                    setError("Invalid data type.");
                }
            } else if (!res.resultflag) {
                setError(res.message);
            } else {
                setError('No data found.');
            }
        }).catch((error) => {
            setError('System error occurred!! please try again.');
        })
        .finally(() => {
            setLoading(false);
        });
    }

    const onReset = () => {
        getFields(props.apiurl);
    }

    useEffect(() => {
        if (discomid){
            let samplelink = process.env.REACT_APP_API_ENDPOINT + '/uploads/quality-monitoring/Pre-Dispatch-Inspection.xlsx';
            setSampleFileLink(samplelink);
        }
    }, [discomid]);

    useEffect(() => {
        setRefresh(false);
        if (props.refresh !== undefined && props.refresh === true) {
            setRefresh(true);
        }
    }, [props.refresh]);

    useEffect(() => {
        if (props.selected == 'CreateNewForm2') {
            getFields(props.apiurl);
        }
    }, [props.selected]);

    if (error) {
        return <Alert className='mt-3 mb-3' variant="danger">{error}</Alert>;
    } else {
        return (
                <>
                {error && (
                    <>
                        <Alert className='mt-3 mb-3' variant="danger">{error}</Alert>
                    </>
                )}
                {props.districts != 0 ?
                <form noValidate onSubmit={onSubmit} ref={formData}>
                    <div className="table-responsive RevenueDetailsTable PqTable mt-3">
                            <Block1 field1={fields[0]} />      
                    </div>
                    <div className="formBtnSection justify-content-between is-sticky">
                        {roleid == 2 ?
                            <>
                            <Link to="#" className="btnDraft" onClick={() => saveasdraft()} >
                                Save as Draft
                                </Link>
                            <button className="btn btnSubmit" type="submit">Submit</button>
                            {/* <Link to="#" className="btnDraft" onClick={() => onReset()} >
                                Reset
                            </Link> */}
                            </>
                            : null
                        }
                    </div>
                </form>
                 :
                    <div className="alert alert-info w-100 text-center" role="alert">
                        Please select District
                    </div>      
                }

                {isLoaded ? <LoadingSpinner /> : null}
               </>
        );
    }
};

const CreateNewForm = (props: any) => {
    const [roleid, setRoleid] = useState<any>(0);
    const [username, setUsername] = useState<any>(0);
    const [discomid, setDiscomid] = useState<any>(0);
    useEffect(() => {
        setRoleid(sessionStorage.getItem('roleid'));
        setUsername(sessionStorage.getItem('username'));
        setDiscomid(sessionStorage.getItem('discom_id'));
    }, [roleid]);

    return (
        <>
        {roleid == 0 ? null :
            <CreateNew apiurl={"/apiv1/qmfields/?form_id=176&roleid=" + roleid + "&discom_id=" + discomid+ "&district_id=" + props.districts} districts={props.districts} months={props.months} refresh={props.refresh} selected={props.selected} />
        }
        </>
    )
}
export default CreateNewForm;